import type { NodeOverlay } from './canvasTypes'
import { type CanvasRect, nodeOverlayBounds } from './graphInstrumentation'

export type IsolationNodeRef = { pageId: string; nodeId: string }
export type IsolationStopBadge = IsolationNodeRef & { badge: string }
export type IsolationFocus = { nodeId: string; count: number }
export type IsolationMarker = {
  overlayId: string
  nodeId: string
  badge: string
  bounds: CanvasRect
  focus?: number
}
export type IsolationHighlight = {
  overlayId: string
  nodeId: string
  bounds: CanvasRect
}

function nodeOverlays(
  overlays: NodeOverlay[],
  { pageId, nodeId }: IsolationNodeRef
): NodeOverlay[] {
  return overlays.filter(
    (overlay) => overlay.pageId === pageId && overlay.node.id === nodeId
  )
}

export function projectIsolationMarkers(
  stops: IsolationStopBadge[],
  overlays: NodeOverlay[],
  focus: IsolationFocus | undefined
): IsolationMarker[] {
  return stops.flatMap(({ pageId, nodeId, badge }) =>
    nodeOverlays(overlays, { pageId, nodeId }).map((overlay) => ({
      overlayId: overlay.overlayId,
      nodeId,
      badge,
      bounds: nodeOverlayBounds(overlay),
      focus: focus?.nodeId === nodeId ? focus.count : undefined,
    }))
  )
}

export function projectIsolationHighlights(
  highlights: IsolationNodeRef[],
  overlays: NodeOverlay[]
): IsolationHighlight[] {
  return highlights.flatMap((highlight) =>
    nodeOverlays(overlays, highlight).map((overlay) => ({
      overlayId: overlay.overlayId,
      nodeId: highlight.nodeId,
      bounds: nodeOverlayBounds(overlay),
    }))
  )
}
